import { render, staticRenderFns } from "./GroupCreate.vue?vue&type=template&id=1a1ff79c&scoped=true&"
import script from "./GroupCreate.vue?vue&type=script&lang=js&"
export * from "./GroupCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1ff79c",
  null
  
)

export default component.exports